import { FormattedMessage } from 'react-intl'
import React from 'react'
import routes from './routes'

export const GENERAL_BOARDING_TYPE_ID = 'GB'

export const VISIT_PURPOSE_OTHERS_ID = '4ad7f29b-50a6-e611-80c3-00155df80332'
export const VISITOR_TYPE_TRUCK_DRIVER_ID = 'TDPEO'
export const REJECT_VISIT_OTHERS_ID = '9138698c-09d7-4429-8f7f-8dcd64d6aba2'

export const ASSISTANCE_NEED_ESCORT_CODE = 'NE'
export const ASSISTANCE_NEED_WHEELCHAIR_CODE = [
  'WLKR',
  'WAV',
  'WPA',
  'WHEEL',
  'NC'
]
export const ASSISTANCE_NEED_MOTORIZED_SCOOTER_CODE = ['SCOOT']
export const ASSISTANCE_NEED_SERVICE_DOG_CODE = ['S_ANIMAL', 'SVD', 'SERVANI']
export const ALLOW_ACTION_BUTTON_TEXT = ['CANCEL', 'APPLY']
export const PERSON_TYPE_CODES = ['C', 'V', 'RG']
export const PERSON_TYPES_ROUTE = {
  C: routes.crew,
  V: routes.visitor,
  RG: routes.guest
}
export const PERSON_RESERVATION_GUEST_ID = 'RG'
export const PERSON_CREW_ID = 'C'
export const PERSON_VISITOR_ID = 'V'
export const DOCUMENT_TYPE_VISA = 'V'
export const personTypeCodes = [
  PERSON_CREW_ID,
  PERSON_RESERVATION_GUEST_ID,
  PERSON_VISITOR_ID
]
export const personTypeCodesWithoutCrew = [
  PERSON_RESERVATION_GUEST_ID,
  PERSON_VISITOR_ID
]
export const PERSON_BRAND = ['v']
export const DEFUALT_ROUTE_VM_PERSON_BRAND = ['VV']

export const VISITOR_STATUS_PENDING_APPROVAL = 'Approval Pending'
export const VISITOR_STATUS_APPROVED = 'Approved'
export const VISITOR_STATUS_REJECTED = 'Rejected'

export const CREATE_ALERTS = 'CR'
export const CREATE_MESSAGES = 'CM'
export const CREATE_VISITORS = 'CV'

export const EDIT_ALERTS = 'EA'
export const EDIT_MESSAGES = 'EM'
export const EDIT_VISITORS = 'EV'

export const ALERT_LIST = 'AL'
export const MESSAGE_LIST = 'ML'
export const VISITOR_LIST = 'VL'
export const CREW_LIST = 'CL'
// Crew Role Management entry feature. Application choices are supplied by
// the server-authorized crewManagementApplications query.
export const VIEW_CREW_ROLES_MANAGEMENT = 'ARF'
export const GUEST_LIST = 'GL'
export const IPM_DUTIES_LIST = 'IPMDL'
export const GROUP_MANAGEMENT_CREATION = 'GMC'
export const GROUP_MANAGEMENT_DELETION = 'GMD'

export const VIEW_REPORTS = 'VR'
export const VIEW_EXCEPTION_REPORT = 'EXCR'
export const VIEW_LOCATION_REPORT = 'LOCR'
export const VIEW_MOVEMENT_REPORT = 'MOVR'
export const VIEW_CBP_REPORT = 'CBPR'
export const VIEW_IPM_REPORT = 'IPMR'
export const VIEW_CREATE_RESERVATION = 'CRS'
export const VIEW_MASTER_TEMPLATE = 'BMDT'
export const VIEW_FIDELIO_REPORT = 'RSMISSR'
export const VIEW_PASSENGERS_WITH_ALERTS_REPORT = 'PAR'
export const VIEW_ONBOARD_GUEST_WITH_PAST_DEBARK_DATE_REPORT = 'ODDPR'
export const VIEW_LOCATION_HISTORY_REPORT = 'LHR'
export const VIEW_BOARDING_SLOT_HISTORY_REPORT = 'BSHR'
export const VIEW_SAILOR_FLIGHT_DETAILS_REPORT = 'SFDR'
export const VIEW_EMBARK_DEBARK_PORT_UPDATE_REPORT = 'VEDDR'
export const EXPORT_SAILOR_FLIGHT_DETAILS_REPORT = 'ESFDR'
export const ENABLE_SAILOR_DOCUMENT_RETURNED_TAB = 'ESDRT'
export const SW_ADDON_DETAILS = 'SWD'
export const SEND_LUGGAGE_TAG_EMAILS_FEATURE = 'SLTE'
export const MAX_LUGGAGE_TAG_EMAIL_RECIPIENTS = 200
export const LUGGAGE_TAG_EMAIL_MESSAGE_DEFAULTS = {
  missingSailorId: 'Missing sailor ID',
  cabinNotAssigned: 'Cabin is not assigned',
  invalidEmbarkDate: 'Embark date is missing or invalid',
  embarkDatePassed: 'Embark date and time have passed',
  voyageEnded: 'Voyage has ended',
  alreadyCheckedIn: 'Sailor is already checked in',
  sendFailure: 'Unable to send luggage tag email. Please try again.',
  sendSkipped: 'Luggage tag email was skipped.',
  sendFailed: 'Luggage tag email could not be sent.',
  recipientLimit: 'Select {limit} or fewer eligible sailors.',
  sendSuccess: 'Luggage tag email sent successfully.',
  unknownSailor: 'Unknown sailor',
  close: 'Close',
  moreActions: 'More actions'
}

export const getLuggageTagEmailMessage = (intl, key, values) => {
  const defaultMessage = LUGGAGE_TAG_EMAIL_MESSAGE_DEFAULTS[key] || ''
  const messageValues =
    values && typeof values === 'object' ? values : undefined
  const fallbackMessage = messageValues
    ? Object.keys(messageValues).reduce(
        (message, name) =>
          message.split(`{${name}}`).join(String(messageValues[name])),
        defaultMessage
      )
    : defaultMessage

  if (intl && typeof intl.formatMessage === 'function') {
    const descriptor = {
      id: `Guests.luggageTagEmail.${key}`,
      defaultMessage
    }
    return messageValues
      ? intl.formatMessage(descriptor, messageValues)
      : intl.formatMessage(descriptor)
  }
  return fallbackMessage
}
export const VIEW_VISITOR_BOARDING_SUMMARY = 'VBSR'
export const EXPORT_VISITOR_BOARDING_SUMMARY = 'EVBSR'

export const DEFAULT_SORT_SAILOR_FLIGHT_DETAILS = [
  { id: 'sailorName', desc: false }
]
export const DEFAULT_SORT_CREW_LISTING = [{ id: 'firstName', desc: false }]
export const VIEW_CBP_DASHBOARD = 'CBPDS'
export const EXPORT_BOARDING_SLOT_HISTORY_REPORT = 'EBSHR'
export const EXPORT_PASSENGERS_WITH_ALERTS_REPORTS_LIST = 'EPAR'
export const EXPORT_FIDELIO_REPORT_LIST = 'RSMISSR'
export const GUEST_HISTORY = 'GH'
export const VIEW_BOARDING_COUNT = 'VBCNT'
export const ANNOUNCEMENT = 'ANNC'
export const ASSIGN_BOARDING_GROUP = 'AUBG'
export const EXPORT_GUESTS_LIST = 'EGL'

export const EXPORT_CREW_LIST = 'ECL'
export const EXPORT_VISITORS_LIST = 'EVL'
export const EXPORT_IPM_REPORT_LIST = 'EIPMR'
export const EXPORT_LOCATION_REPORT_LIST = 'ELOCR'
export const EXPORT_MOVEMENT_REPORT_LIST = 'EMOVR'
export const EXPORT_CBP_REPORT_LIST = 'ECBPR'
export const MOVE_BOARDING_SLOT = 'MSL'
export const EXCEPTION_REPORT_SAILOR = 'EXS'
export const MARK_SLOT_ACTIVE_INACTIVE = 'MSLAI'
export const EXPORT_EXCEPTION_REPORT_LIST = 'EEXCR'
export const REVIEWER_FILTER = 'RF'
export const APP_NAME = 'EMBARKATION SUPERVISOR'
export const ENABLE_PHOTO_UPLOAD = 'UVPP'
export const VIEW_ALERT_DETAILS = 'VAD'
export const ADD_NEW_GUEST = 'AG'
export const UPDATE_EMBARK_DEBARK_DATE = 'UEDD'
export const EDIT_EMBARK_DEBARK_DATE = 'EGD'
export const VIEW_MESSAGE_DETAILS = 'VMD'
export const VIEW_VISITORS = 'VV'
export const CREATE_VISIT_LONG_DURATION = 'CVILD'
export const EDIT_VISITOR_LONG_DURATION = 'EVLD'
export const EDIT_VISIT_LONG_DURATION = 'EVILD'
export const APPROVE_REJECT_LONG_DURATION_VISIT = 'ARVILD'
export const VIEW_BOARDING_MANAGEMENT = 'BMNGT'
export const CANCEL_RESERVATION = 'CNRG'
export const UNCHECKIN_GUEST = 'UCI'
export const CANCEL_RESERVATION_STATEROOM_PARTY = 'CNRGALLSR'
export const STATEROOM_LIST = 'SRL'
export const MARK_STATEROOM_AVAILABLE = 'MSRA'
export const MARK_STATEROOM_OOO = 'MSRO'
export const ASSIGN_UPGRADE_STATEROOM = 'AUSR'
export const ADD_SLOT = 'ASL'
export const REMOVE_SLOT = 'RSL'
export const DISABLE_SLOT = 'DSL'
export const EDIT_VISITORS_VISIT = 'EVI'

export const DELETE_ALERTS = 'DA'
export const DELETE_VISITORS = 'DV'
export const DELETE_MESSAGES = 'DM'

export const VIEW_VISITOR_DOCUMENT_IMAGE = 'VVD'
export const EDIT_VISITOR_DOCUMENT_IMAGE = 'EVD'
export const DOWNLOAD_VISITOR_DOCUMENT_IMAGE = 'DLVD'

export const VIEW_VOYAGE_PORT_TERMINALS = 'VVPT'
export const EDIT_VOYAGE_PORT_TERMINALS = 'EVPT'
export const VIEW_PORT_TERMINALS = 'VPT'
export const CREATE_PORT_TERMINALS = 'CPT'
export const UPDATE_PORT_TERMINALS = 'UPT'
export const DELETE_PORT_TERMINALS = 'DPT'

export const MANAGE_IPM_DUTIES = 'MIPMD'
export const APPROVE_REJECT_VISIT = 'ARV'
export const SETTINGS = 'S'
export const INTELLIGENCE_AND_MATRICS_DASHBOARD = 'IMD'
export const GUEST_DASHBOARD = 'SAILDASH'
export const VISITOR_DASHBOARD = 'VSTDASH'
export const CREW_DASHBOARD = 'CREWDASH'

export const VISITOR_ACTIVATE = 'VACT'
export const VISITOR_DE_ACTIVATE = 'VDACT'
export const VISITOR_BULK_ACTIVATE = 'VBACT'
export const VISITOR_BULK_DE_ACTIVATE = 'VBDACT'
export const VIEW_BOARDING_SLOT_REPORT = 'BSR'
export const EXPORT_BOARDING_SLOT_REPORT = 'EBSR'
export const VIEW_DOCUMENT_TYPE_BREAKDOWN_REPORT = 'VSDTR'
export const EXPORT_DOCUMENT_TYPE_BREAKDOWN_REPORT = 'ESDTR'
export const VIEW_SAILOR_NATIONALITY_REPORT = 'VSNR'
export const EXPORT_SAILOR_NATIONALITY_REPORT = 'ESNR'

export const DASHBOARD_MODULE = ['SAILDASH', 'VSTDASH', 'CREWDASH']
export const DATE_FORMAT_REPORTS_LIST = [
  'movement',
  'location',
  'cbp',
  'alertsReports'
]
export const DATE_FORMAT_KEY = [
  'boardingStatusChangedDate',
  'alertCreationDate',
  'alertClearanceDate',
  'startDate',
  'endDate'
]

export const UPLOAD_IPM_DUTIES = 'UIPMD'
export const UPLOAD_VISITORS = 'UV'
export const IPM_EXCEL_COLUMN_LIST = {
  group: 0,
  safetyNo: 1,
  rank: 2,
  department: 3,
  positionNumber: 4,
  role: 5,
  inPort: 6,
  atAnchor: 7
}

export const IPM_TYPES = {
  GROUP: 'GROUP',
  PERCENTAGE: 'PERCENTAGE'
}

export const SecurityAdmin = 'SA'
export const SHORE_SIDE_SECURITY_ADMIN = 'SSA'
export const OFFICE_ADMIN = 'OA'
export const ApproverRole = 'APRV'
export const VXP_TERMINAL_MANAGER = 'TM'
export const SW_FARE_CODE_ALLOWLIST = [
  'BASE',
  'ESSENTIAL',
  'LEGACYFARE',
  'PREMIUM'
]
export const RequestorRole = 'REQ'
export const SECURITY_OFFICER_DESIGNATION = 'Security Officer'
export const OUT_OF_ORDER_STATUS_CODE = '2'
export const BOARDINGSLOTS_FILTER_TABLE_COLUMNS = ['boardingNumber']

export const checkedInStatusCodes = {
  checkedIn: 'CHECKED_IN',
  notCheckedIn: 'NOT_CHECKED_IN',
  onlineCheckInComplete: 'OCI_DONE_APPROVED',
  onlineCheckInPending: 'OCI_DONE_PENDING',
  yetToEmbark: 'YET_TO_EMBARK',
  yetToLeave: 'YET_TO_DEBARK',
  ociNotComplete: 'OCI_NOT_DONE',
  checkedOut: 'CHECKED_OUT',
  notCheckedInEmbarkingToday: 'NOT_CHECKED_IN_EMBARKING_TODAY',
  notCheckedOutDebarkingToday: 'NOT_CHECKED_OUT_DEBARKING_TODAY'
}

export const voyageStatusesCodes = {
  inVoyage: true,
  notInVoyage: false
}

export const visitorFilterModes = {
  allFilters: 'ALL_FILTERS',
  pendingApprovals: 'PENDING_APPROVALS'
}

export const boardingStatusCodes = {
  onboard: 'ONBOARD',
  ashore: 'ASHORE',
  approved: 'approved',
  rejected: 'rejected',
  expectedToday: 'expectedToday'
}
export const cardStatusCodes = {
  assigned: 'ASSIGNED',
  unassigned: 'UNASSIGNED',
  nonassigned: 'NONASSIGNED'
}
export const disembarkedCodes = {
  disembarked: 'CHECKOUT',
  embarked: 'COMPLETED',
  notEmbarked: 'NOT_CHECKIN'
}
export const DISEMBARKED_CODE = ['CHECKOUT', 'COMPLETED', 'NOT_CHECKIN']
export const VISITOR_BOARDING_STATUS = ['ONBOARD', 'ASHORE']
export const VISITOR_FILTER_FOR_DASHBOARD_DETAILS = {
  onboard: ['status', 'statusTypeCode'],
  ashore: ['status', 'statusTypeCode', 'cardStatus'],
  approved: ['visitStatuses'],
  rejected: ['visitStatuses'],
  embarkingToday: ['status', 'visitStatuses', 'statusTypeCode', 'cardStatus'],
  checkOut: ['status', 'statusTypeCode', 'cardStatus']
}
export const VisitTypeCode = {
  dayVisit: 'day',
  durationVisit: 'duration'
}

export const VisitorStatusCode = {
  active: 'active',
  inactive: 'inactive'
}

export const visitStatusCodes = {
  pendingApproval: 'pending',
  approved: 'approved',
  rejected: 'rejected'
}

export const documentImageStatusCode = {
  present: 'present',
  notPresent: 'does not exist'
}

export const VISIT_STATUSES = {
  approved: 'Approved',
  rejected: 'Rejected',
  pending: 'Pending Approval',
  expired: 'Expired'
}

export const VISITS_FIELDS_TYPE = {
  fullVisitsFields: 'fullVisitsFields',
  partialVisitsFields: 'partialVisitsFields'
}

export const clearanceStatusCodes = {
  isCleared: 'true',
  isNotCleared: 'false'
}

export const assignedCodes = {
  isAssigned: 'true',
  isNotAssigned: 'false'
}

export const USCountryCode = 'US'

export const reportTypes = {
  exception: 'exception',
  wearableAssigned: 'wearableAssigned',
  location: 'location',
  movement: 'movement',
  cbp: 'cbp',
  ipm: 'ipm',
  locationHistory: 'locationHistory',
  alertsReports: 'alertsReport',
  boardingSlotHistoryReports: 'boardingSlotHistoryReports',
  sailorFlightDetails: 'sailorFlightDetails'
}

export const clearanceReportTypes = {
  documentTypeBreakdown: 'documentTypeBreakdown',
  sailorNationality: 'sailorNationality',
  sailorAshoreVisit: 'sailorAshoreVisit'
}

export const EXCEPTION_REPORTS = {
  missingPictureReports: 'MISSING-PICTURE',
  expiredCard: 'EXPIRED-CARD',
  notCheckedInOnboard: 'OB-NTC',
  checkedInNotOnboard: 'TC-NOB',
  visitorOnboard: 'VISITOR-ONBOARD',
  wearableAssigned: 'WEARABLE-ASSIGNED',
  reservationsMissingInFidelioReports: 'MISSING-RESERVATION'
}

export const VISITOR_KEYS_MAPPING = {
  firstName: 'firstName',
  lastName: 'lastName',
  dateOfBirth: 'birthDate',
  genderCode: 'genderCode',
  contactNumber: 'phone',
  citizenShipCountryCode: 'citizenShipCountryCode',
  companyName: 'companyName',
  documentTypeCode: 'documentTypeCode',
  number: 'number',
  employeeNumber: 'employeeNumber',
  visitorNotes: 'note',
  visitorTypeCode: 'visitorTypeCode',
  licensePlateNumber: 'additionalInfo',
  validForShip: 'propertyId',
  portCode: 'portCode',
  visitPurposeId: 'visitPurposeId',
  boardingTypeCode: 'boardingTypeCode',
  startDate: 'startDate',
  endDate: 'endDate',
  departmentId: 'visitorDepartmentId',
  departmentPOC: 'departmentPOC'
}
export const UPDATE_VISIT_REQUIRED_FIELD = [
  'startDate',
  'endDate',
  'boardingTypeCode'
]

export const defaultSlotTime = 45
export const INFO_ALERT_CODE = 'IN'

export const BROADCAST_MESSAGES = {
  leadersMessage: 'BC_LDR_MSG',
  initiative: 'BC_INI_MSG',
  importantMessage: 'BC_IMP_MSG'
}

export const TERMINAL_CHECKEDIN_STATUS_MAPPING = {
  COMPLETED: (
    <FormattedMessage id="Guests.completed" defaultMessage="Checked-In" />
  ),
  CHECKOUT: (
    <FormattedMessage id="Guests.checkout" defaultMessage="Checked-Out" />
  ),
  NOT_COMPLETED: (
    <FormattedMessage
      id="Guests.notCompleted"
      defaultMessage="Check-In Pending"
    />
  )
}
export const ZERO_AMOUNT = 0
export const VIP_BOARDING_NUMBER = 0
export const PRIORITY_BOARDING_NUMBER = 25

export const BOARDING_STATUS_MAPPING = {
  ONBOARD: <FormattedMessage id="Guests.onboard" defaultMessage="Onboard" />,
  ASHORE: <FormattedMessage id="Guests.ashore" defaultMessage="Ashore" />
}
export const MAX_SLOT_DIFFERENCE = 18000000

export const STATEROOM_FILTER_STATUS = {
  available: 1,
  outOfOrder: 2,
  occupied: 3,
  blocked: 4
}
export const MESSAGE_INFO = {
  messageCode: '5003',
  message: 'common service request message',
  severity: 'INFO'
}
export const ERROR_INFO = {
  messageCode: '9001',
  message: 'common service request error message',
  severity: 'ERROR'
}

export const BOARDING_PATTERN_TYPE = [
  {
    name: (
      <FormattedMessage
        id="BoardingGroupModal.BoardingPatternTypeOLCI"
        defaultMessage="Online Check-in first"
      />
    ),
    label: (
      <FormattedMessage
        id="BoardingGroupModal.BoardingPatternTypeOLCI"
        defaultMessage="Online Check-in first"
      />
    ),
    value: 'OLCI'
  },
  {
    name: (
      <FormattedMessage
        id="BoardingGroupModal.BoardingPatternTypeFCFS"
        defaultMessage="First Come,First Serve"
      />
    ),
    label: (
      <FormattedMessage
        id="BoardingGroupModal.BoardingPatternTypeFCFS"
        defaultMessage="First Come,First Serve"
      />
    ),
    value: 'FCFS'
  }
]

export const RESERVATION_STATUS_CODE = { reserved: 'RS', cancelled: 'CN' }

export const ENTITY_TYPES = ['ReservationGuest', 'Guest', 'Reservation']

export const ATTRIBUTE_CATEGORY = {
  entityValue: 'attribute',
  field: 'attributeid'
}
export const DEPARTMENT_ID = 'teamMemberDepartmentId'
export const ADD = 'add'
export const ACI_VALIDATE = 'ACI/VALIDATE'
export const ALERT_CODE = 'alertTypeCode'
export const MODIFY = 'modify'
export const DESCRIPTION = 'description'
export const OLD = 'old'
export const NEW = 'new'
export const DATE_TIME = 'dateTime'
export const CREATION = 'Creation'
export const ALERT_CREATED_BY = 'alertCreatedBy'
export const FIELD = 'field'
export const GUEST = 'GUEST'
export const USER = 'user'
export const TERMINAL_CHECKIN = 'TC'
export const PERSON_STATUS = 'PersonStatus'
export const MESSAGE = 'MESSAGE'
export const ALERT = 'ALERT'
export const RESERVATION_GUEST = 'ReservationGuest'
export const SYSTEM = 'System'
export const LOCATION = 'location'
export const TITLE = 'title'
export const STATUS_CODE = 'statusTypeCode'
export const GANGWAY_LOCATION_ID = 'gangwayLocationId'
export const STATUS = 'status'
export const ONBOARD = 'ONBOARD'
export const CHECKED_IN = 'CHECKED-IN'
export const CHECKED_OUT = 'CHECKOUT'
export const COMPLETED = 'COMPLETED'
export const ASHORE = 'ASHORE'
export const NOT_COMPLETED = 'NOT_COMPLETED'
export const CREW = 'Crew'
export const VISITOR = 'Visitor'
export const NOT_CHECKED_IN = 'NOT CHECKED-IN'
export const RESERVATION = 'Reservation'
export const GUEST_TERMINAL_CHECKIN = 'GTCI'
export const UNMASKED_SAILOR = 'UMSD'
export const UNMASKED_CREW = 'UMCD'
export const UNMASKED_VISITOR = 'UMVD'
export const CARD_STATUS = 'cardStatus'
export const ASSIGNED = 'ASSIGNED'
export const UNASSIGNED = 'UNASSIGNED'
export const NONASSIGNED = 'NONASSIGNED'
export const CARD_ASSIGNED = 'CARD ASSIGNED'
export const CARD_UNASSIGNED = 'CARD UNASSIGNED'
export const OTHER = 'OTHER'
export const PORT_TERMINAL_COMING_SOON = {
  name: 'NA',
  address: 'NA',
  coordinate: 'NA',
  portCode: 'NA',
  isDefault: false
}
export const NAMES = {
  dueDate: 'Due Date',
  alertTypeCode: 'Alert Type',
  description: 'Description',
  expiryDate: 'Expiry Date',
  teamMemberDepartmentId: 'Department',
  isDeleted: 'Deletion',
  isCleared: 'Alert Cleared',
  isRead: 'Message Acknowledged'
}
export const masterBoardingdropdownActions = {
  updateSlot: 'UPDATE_SLOT',
  addSlot: 'ADD_SLOT',
  remove: 'REMOVE',
  changeTimeRange: 'CHANGE_TIME_RANGE',
  moveSlot: 'MOVE'
}
export const MASTER_DATA = 'MasterDataTable'
export const BOARDING_NUMBER = 'boardingNumber'
export const authHandlerObject = {}
export const APP_AUTH_NAME = 'embarkationAdminUI'

// URLS
export const LOGIN_URL = 'crew-embarkation-admin/login'
export const VISITOR_MEDIA_URL = 'mediaitems'
export const RESERVATION_GUEST_LIST =
  'crew-embarkation-admin/reservation-guests'
export const LOGS = 'logs'
export const UI_CONFIG = 'crew-embarkation-admin/uiconfig'
export const GLOBAL_SEARCH = 'crew-embarkation-admin/search'
export const STATEROOMS_LIST = 'crew-embarkation-admin/staterooms'
export const RESOURCES = 'crew-embarkation-admin/resources'
export const SLOTS = 'crew-embarkation-admin/slots'
export const RESERVATION_GUESTS_SEARCH =
  'crew-embarkation-admin/reservation-guests/search'
export const LOCATION_REPORT = 'gangway-reports/location'
export const TEAM_MEMBER_SEARCH = 'crew-embarkation-admin/team-members/search'
export const IPM_SINGLE_ASSIGN =
  'crew-embarkation-admin/in-port-manning/assign-duty'
export const IPM_SINGLE_UNASSIGN =
  'crew-embarkation-admin/in-port-manning/unassign-duty/{ipmDutyAssignmentId}'
export const VISITOR_IMPORT = 'gangway/visitors/import'
export const GUESTTYPES_URL = 'guesttypes'
export const CREATE_RESERVATION_URL =
  'reservationguests/process-reservation-data'
export const IPM_IMPORT_URL = 'gangway/in-port-manning/import'
export const IPM_PERCENTAGE_CONFIG_IMPORT_URL =
  'gangway/in-port-manning/percentage-config/import'
export const STATEROOMS_SEARCH = 'staterooms/search'
export const RESERVATIONGUESTS_SEARCH = 'reservationguests/search'
export const GET_GUESTRESERVATION = 'reservationguests/search/findByIds'
export const GET_STATEROOMCATEGORIES = 'staterooms/stateroomscategories'
export const GET_STATEROOMCAPACITIES = 'staterooms/capacities'
export const POST_STATEROOMSTATUS = 'staterooms/updatestatus/batch'
export const RESERVATION_GUESTS = 'reservationguests'
export const GUEST_STATEROOMPARTY_URL =
  'reservationguests/search/guests/details'
export const GUEST_SEARCHPARTY_URL = 'connections/search'
export const VOYAGES_URL = 'voyages'
export const UPGRADE_STATEROOM_URL =
  'gangway/reservation-guest/upgradestateroom'
export const RESERVATIONGUESTS_BATCHURL = 'reservationguests/batch/v1'
export const RESERVATION_GUESTUPDATE_URL = 'gangway/reservation-guest/update'
export const ALERTMESSAGE_DETAILURL = 'alerts/findbyid'
export const UI_CLIENT_ID = '0a21443d-210b-4b81-8b56-b497d369c0d0'
export const PERSONDETAILS_GET = 'userprofiles/getpersondetails'
export const ATTRIBUTE_URL = 'attributes'
export const ALERT_REPORT_URL = 'gangway-reports/passengers'
export const EXPORT_VISITOR_URL = 'gangway/visitors/export'
export const EXPORT_LOCATION_HISTORY_REPORT_URL =
  'gangway-reports/location-movement/export'
export const EXPORT_BOARDING_SLOT_HISTORY_REPORT_URL =
  'gangway-reports/boarding-slot-history-report/export'
export const EXPORT_BOARDING_SLOT_REPORT_URL =
  'boardingnumber/exportboardingslotreport'
export const EXPORT_GUEST_FLIGHT_DETAILS_REPORT_URL =
  'gangway-reports/guest-flight-details/export'
export const EXPORT_DOC_TYPE_BREAKDOWN_URL = 'gangway-reports/clearance/guest-document-types/export'
export const EXPORT_DOC_WISE_SAILOR_URL = 'gangway-reports/clearance/guest-document-types/guests/export'
export const EXPORT_SAILOR_NATIONALITY_URL =
  'gangway-reports/clearance/guest-nationality/export'
export const EXPORT_NATIONALITY_WISE_SAILOR_URL =
  'gangway-reports/clearance/guest-nationality/guests/export'
export const UPDATE_MASTER_DATA_URL = 'boardingnumber/update/masterdata'
export const BOARDING_EXCEPTION_REPORT_URL =
  'gangway/guest/boardingnumber/exception'
export const SAILOR_VIP_ICONS_URL = 'content/crewApp/icons'
export const CBP_MESSAGE_SCHEDULE_URL = 'cbpdashboard/messageschedule'
export const CBP_VCO_MESSAGE_URL = 'cbpdashboard/fetchmessagesbygenerationtype'
export const CBP_LATEST_ENOAD_URL = 'cbpdashboard/latestenoad'
export const CBP_GET_LEGS_URL = 'cbpdashboard/fetchvoyagelegdetails'
export const CBP_SEND_VCO_MESSAGE_URL = 'cbpdashboard/manualtriggermessage'
export const CBP_DOWNLOAD_ENOAD_URL = 'cbpdashboard/retrievemessages'
export const CBP_COMPARATOR_URL = 'cbpdashboard/comparator'
export const CBP_GENERATE_ENOAD_BATCH_URL = 'cbpdashboard/genratebatchenoad'
export const CBP_SEND_BATCH_MESSAGE_URL =
  'cbpdashboard/sendexplicitmessagetocbp'
export const CBP_FILE_EXTENSION = 'zip'
export const cbpVxpMxpComparisonColumns = ['Field Name', 'VXP', 'MXP']
export const cbpVxpBatchEnoadComparisonColumns = [
  'Field Name',
  'Batch API',
  'eNOAD'
]
export const boardingSlotFilterFieldNames = [
  {
    label: 'Slot Active',
    value: 'isActive'
  },
  {
    label: 'Slot In-Active',
    value: 'inActive'
  },
  {
    label: 'Slot Enable',
    value: 'isEnabled'
  },
  {
    label: 'Slot Disable',
    value: 'disabled'
  },
  {
    label: 'Capacity',
    value: 'expectedGuestCount'
  }
]

export const paginationValue = {
  defaultPageSize: 20,
  allItemsPageSize: 99999
}
export const REJECTION_VISIT_OTHERS_ID = '9138698c-09d7-4429-8f7f-8dcd64d6aba2'
export const crewCardValue = {
  onboard: 'onboard',
  ashore: 'ashore',
  checkedInStatus: 'CHECKED_IN',
  embarkingToday: 'EMBARKING_TODAY',
  leavingToday: 'LEAVING_TODAY',
  notCheckedInEmbarkingToday: 'NOT_CHECKED_IN_EMBARKING_TODAY',
  notCheckedOutDebarkingToday: 'NOT_CHECKED_OUT_DEBARKING_TODAY'
}
export const allowedProfilePhotoTypes = ['image/png', 'image/jpeg', 'image/jpg']
export const allowedDocTypes = [
  'application/pdf',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/jpeg',
  'image/jpg'
]

export const MAX_VISITOR_DOCUMENT_UPLOAD_SIZE = 5
export const convertToBytes = sizeInMb => sizeInMb * 1024 * 1024

export const docErrorMsg = 'Incorrect file format'
export const VISITOR_MINIMUM_AGE = 18 // in years
export const pdfIntValue = '25504446'
export const mappingType = 'P-P'
export const connectionState = 'CF'
export const minorAgePopupTitle = 'Visitor Age Confirmation'
export const docTypes = {
  arc: 'ARC',
  bc: 'BC',
  con: 'CON',
  dl: 'DL',
  esta: 'ESTA',
  eta: 'ETA',
  edl: 'EDL',
  etias: 'ETIAS',
  euid: 'EUID',
  fast: 'FAST',
  gloent: 'GLOENT',
  govissid: 'GOVISSID',
  nid: 'NID',
  passport: 'P',
  ppc: 'PPC',
  prc: 'PRC',
  sentri: 'SENTRI',
  stissid: 'STISSID',
  usVisa: 'USVISA',
  visa: 'V'
}

export const ruleEntities = {
  visitorIdentification:
    'com.decurtis.dxp.rules.entities.VisitorIdentification',
  visitorVisitInformation:
    'com.decurtis.dxp.rules.entities.VisitorVisitInformation',
  visitorPersonalInformation:
    'com.decurtis.dxp.rules.entities.VisitorPersonalInformation'
}
export const VISITOR_VISIT_RULE_ENTITY_NAME = 'VisitorVisitInformation'
export const showPopupFields = {
  usVisaDocument: 'showPopUp_USVISA',
  earlyBoardingVisitType: 'showPopUp_EB',
  age: 'showPopUp_Age',
  tomorrowVisitDate: 'showPopUp_visitDate'
}
export const documentCollectionStatusCodes = {
  collected: 'COLLECTED',
  notCollected: 'NOT_COLLECTED',
  returned: 'RETURNED'
}

export const rtsStatusCodes = {
  completed: 'COMPLETED',
  nonCompleted: 'NOT_COMPLETED'
}

export const cruiseContractStatusLabels = {
  completed: 'Completed',
  notCompleted: 'Not Completed',
  notApplicable: 'NA',
  otherApplication: 'Other Application'
}

export const mociStatusCodes = {
  notReady: 'NOT_READY',
  approved: 'APPROVED',
  pending: 'PENDING',
  rejected: 'REJECTED'
}

export const visaEntriesCodes = {
  single: 'SINGLE',
  double: 'DOUBLE',
  multiple: 'MULTIPLE'
}

export const MOVEMENT_TYPE_OPTIONS = [
  { id: MESSAGE, label: MESSAGE },
  { id: ALERT, label: ALERT },
  { id: ONBOARD, label: ONBOARD },
  { id: ASHORE, label: ASHORE },
  { id: CHECKED_IN, label: CHECKED_IN },
  { id: NOT_CHECKED_IN, label: NOT_CHECKED_IN },
  { id: CARD_ASSIGNED, label: CARD_ASSIGNED },
  { id: CARD_UNASSIGNED, label: CARD_UNASSIGNED }
]

export const SELECT_VOYAGE_MESSAGE = 'Plesae Select a Voyage'
export const PORT_CODE_CCC = 'CCC'
